import React from 'react';
import { Fallback } from '../../Fallback';
import styles from './MapLoader.module.scss';

const MapLoader = () => {
	return (
		<div className={styles.loader}>
			<Fallback />
		</div>
	);
};

export default MapLoader;
